import React, { useContext, useEffect, useRef, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "react-modal";
import axios from "axios";
import { axiosGet } from "../../../Apis/axiosMethods";
import { default_image } from "../../../Imgaes";

Modal.setAppElement("#root");
Modal.defaultStyles.overlay.position = "fixed";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#f9fafb",
    borderRadius: "10px",
    zIndex: 9999999999,
    padding: "20px",
    overflow: "hidden",
    border: "none",
    position: "absolute",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 999999999,
    backgroundColor: "rgba(0,0,0,0.93)",
  },
};

const PartImages = ({ ART_ID, SUP_ID, TITLE, PART_NUMBER, setSticky, setThumbnail }) => {
  const [medias, setMedias] = useState([]);
  const [selectedImg, setSelectedImg] = useState(0);
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [activeSliderIndex, setActiveSliderIndex] = useState(0);

  const sliderRef = useRef(null);

  function openModal() {
    setSticky(false);
    setIsOpen(true);

    setTimeout(() => {
      sliderRef.current?.slickGoTo(selectedImg);
    }, 150);
  }

  function closeModal() {
    setSticky(true);
    setIsOpen(false);
  }

  useEffect(() => {
    GetPartMedias();
  }, [ART_ID]);

  // lock body scroll + prevent page jump
  useEffect(() => {
    const siteHeader = document.querySelector("header");
    const navbar = document.querySelector(".navbar");
    const stickySearch = document.querySelector(".sticky-search");

    if (modalIsOpen) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      siteHeader && (siteHeader.style.visibility = "hidden");
      navbar && (navbar.style.visibility = "hidden");
      stickySearch && (stickySearch.style.visibility = "hidden");
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.body.style.paddingRight = "0px";

      siteHeader && (siteHeader.style.visibility = "visible");
      navbar && (navbar.style.visibility = "visible");
      stickySearch && (stickySearch.style.visibility = "visible");
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.body.style.paddingRight = "0px";

      siteHeader && (siteHeader.style.visibility = "visible");
      navbar && (navbar.style.visibility = "visible");
      stickySearch && (stickySearch.style.visibility = "visible");
    };
  }, [modalIsOpen]);

  // keyboard support
  useEffect(() => {
    const handleKeyNavigation = (e) => {
      if (!modalIsOpen || !sliderRef.current) return;

      if (e.key === "ArrowRight") {
        sliderRef.current.slickNext();
      }

      if (e.key === "ArrowLeft") {
        sliderRef.current.slickPrev();
      }

      if (e.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeyNavigation);

    return () => {
      window.removeEventListener("keydown", handleKeyNavigation);
    };
  }, [modalIsOpen]);

  // const GetPartMedias = async () => {
  //   try {
  //     setLoadingMedia(true);

  //     const { data } = await axiosGet(`/Parts/GetAFMPartMedias`, {
  //       lang: "en",
  //       part_number: PART_NUMBER,
  //       sup_id: SUP_ID,
  //     });

  //     if (data?.success) {

  //       const sortedMediaArray = (data.data || []).sort((a, b) => {
  //         if (a.ART_MEDIA_TYPE === "URL" && b.ART_MEDIA_TYPE !== "URL") return -1;
  //         if (a.ART_MEDIA_TYPE !== "URL" && b.ART_MEDIA_TYPE === "URL") return 1;
  //         return 0;
  //       });

  //       const filteredMedia = sortedMediaArray.filter((media) => media.ART_MEDIA_TYPE !== "URL" && media.ART_MEDIA_TYPE !== "PDF");
  //       setThumbnail(data?.data[0]?.MEDIA_SOURCE || default_image)
  //       setMedias(filteredMedia);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching media:", error);
  //   } finally {
  //     setLoadingMedia(false);
  //   }
  // };


  const GetPartMedias = async () => {
    try {
      setLoadingMedia(true);
      setMedias([]);

      const { data } = await axiosGet(`/Parts/GetAFMPartMedias`, {
        lang: "en",
        part_number: PART_NUMBER,
        sup_id: SUP_ID,
      });

      if (data?.success) {
        const sortedMediaArray = (data.data || []).sort((a, b) => {
          if (a.ART_MEDIA_TYPE === "URL" && b.ART_MEDIA_TYPE !== "URL") return -1;
          if (a.ART_MEDIA_TYPE !== "URL" && b.ART_MEDIA_TYPE === "URL") return 1;
          return 0;
        });

        const filteredMedia = sortedMediaArray.filter(
          (media) =>
            media.ART_MEDIA_TYPE !== "URL" &&
            media.ART_MEDIA_TYPE !== "PDF"
        );

        setMedias(filteredMedia);
        setSelectedImg(0);
        setActiveSliderIndex(0);

        setThumbnail(filteredMedia[0]?.MEDIA_SOURCE || default_image);
      } else {
        setMedias([]);
        setThumbnail(default_image);
      }
    } catch (error) {
      console.error("Error fetching media:", error);
      setMedias([]);
      setThumbnail(default_image);
    } finally {
      setLoadingMedia(false);
    }
  };

  // const handleMediaClick = (index) => {
  //   setSelectedImg(index);
  // };

  const handleMediaClick = (index) => {
    const selectedMedia = medias[index];

    if (!selectedMedia) return;

    const reorderedMedia = [
      selectedMedia,
      ...medias.filter((_, i) => i !== index),
    ];

    setMedias(reorderedMedia);

    setSelectedImg(0);
    setActiveSliderIndex(0);

    setThumbnail(
      selectedMedia.MEDIA_SOURCE || default_image
    );

    if (modalIsOpen) {
      sliderRef.current?.slickGoTo(0);
    }
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#000",
          borderRadius: "100px",
          right: "10px",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "#000",
          borderRadius: "100px",
          left: "10px",
          zIndex: 1000,
        }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => {
      setActiveSliderIndex(current);
      setSelectedImg(current);
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const ZoomableImage = ({ src }) => {
    const [scale, setScale] = useState(1);
    const [origin, setOrigin] = useState("50% 50%");

    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      const x = (offsetX / rect.width) * 100;
      const y = (offsetY / rect.height) * 100;

      setOrigin(`${x}% ${y}%`);
    };

    return (
      <div
        style={{
          width: "450px",
          height: "450px",
          margin: "auto",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "zoom-in",
        }}
        onMouseEnter={() => setScale(2)}
        onMouseMove={handleMouseMove}
        onMouseLeave={() => setScale(1)}
      >
        <img
          alt="Part"
          src={src || default_image}
          style={{
            width: "auto",
            height: "100%",
            transform: `scale(${scale})`,
            transformOrigin: origin,
            transition: "transform 0.1s ease",
          }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = default_image;
          }}
        />
      </div>
    );
  };

  // const PictureFrame = () => {
  //   if (!medias.length) return null;

  //   const thumb = medias[selectedImg];

  //   return (
  //     <div style={{ minHeight: "300px", textAlign: "center" }} onClick={openModal}>
  //       <ZoomableImage src={`${thumb?.MEDIA_SOURCE}`} />
  //     </div>
  //   );
  // };

  const PictureFrame = () => {
    // Wait until API response is received
    if (loadingMedia) {
      return (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>Loading image...</p>
        </div>
      );
    }

    // Show default image only if API has no valid images
    if (!medias.length) {
      return (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={default_image}
            alt="Default Part"
            style={{
              maxWidth: "100%",
              height: "300px",
              objectFit: "contain",
            }}
          />
        </div>
      );
    }

    const thumb = medias[selectedImg] || medias[0];

    return (
      <div
        style={{ minHeight: "300px", textAlign: "center" }}
        onClick={openModal}
      >
        <ZoomableImage
          src={thumb?.MEDIA_SOURCE || default_image}
        />
      </div>
    );
  };

  const Thumbnails = () => (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        overflowY: "hidden",
        padding: "10px",
        width: "500px",
        scrollbarWidth: "thin",
      }}
    >
      {medias.map((img, index) => (
        <div
          key={index}
          style={{
            flex: "0 0 auto",
            marginRight: "10px",
            cursor: "pointer",
            width: "100px",
            height: "100px",
            border: selectedImg === index ? "2px solid #ff8b40" : "1px solid #CCC",
            borderRadius: "6px",
          }}
          onClick={() => handleMediaClick(index)}
        >
          <img
            alt="thumb"
            src={`${img?.MEDIA_SOURCE}`}
            style={{
              borderRadius: "6px",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div>
      {loadingMedia && <p>Loading media...</p>}

      <PictureFrame />
      <Thumbnails />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        bodyOpenClassName="ReactModal__Body--open"
        htmlOpenClassName="ReactModal__Html--open"
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        portalClassName="PartImageModalPortal"
      >
        <div className="image-slider-container mt-3" style={{ width: "800px" }}>
          <div style={{ fontSize: "22px", fontWeight: "600", color: "#000" }}>{TITLE}</div>
          <div style={{ color: "#59666e", fontSize: "12px", textAlign: "left" }}>
            Part Number: {PART_NUMBER}
          </div>

          <Slider ref={sliderRef} {...settings}>
            {medias.map((thumb, index) => (
              <ZoomableImage key={index} src={`${thumb?.MEDIA_SOURCE}`} />
            ))}
          </Slider>

          <br />
          <span>{medias.length} Images</span>

          <div
            style={{
              display: "flex",
              overflowX: "auto",
              padding: "10px",
              marginTop: "10px",
              width: "800px",
            }}
          >
            {medias.map((img, index) => (
              <div
                key={index}
                style={{
                  flex: "0 0 auto",
                  marginRight: "10px",
                  cursor: "pointer",
                  width: "150px",
                  height: "150px",
                  border: activeSliderIndex === index ? "2px solid #ff8b40" : "1px solid #CCC",
                  borderRadius: "6px",
                }}
                onClick={() => {
                  setActiveSliderIndex(index);
                  sliderRef.current?.slickGoTo(index);
                }}
              >
                <img
                  alt="thumb"
                  src={`${img?.MEDIA_SOURCE}`}
                  width={150}
                  height={150}
                  style={{ borderRadius: "6px", objectFit: "cover" }}
                />
              </div>
            ))}
          </div>
        </div>

        <span
          style={{
            top: "10px",
            right: "15px",
            position: "absolute",
            cursor: "pointer",
            fontSize: "20px",
          }}
          onClick={closeModal}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </span>
      </Modal>
    </div>
  );
};

export default PartImages;